import { apiRequest } from '@/api/request.js'
export const getAllinpayMemberInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/get_user_info',
    method: 'GET'
  })
}
export const listAllinpayBankCards = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/query_bank_card',
    method: 'GET'
  })
}
export const getAllinpayOrderStatus = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/order/get_order_status',
    method: 'GET'
  })
}
export const queryAllinpayBalance = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/order/query_balance',
    method: 'GET'
  })
}
export const applyAllinpayBankCardBind = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/apply_bind_bank_card',
    method: 'POST'
  })
}
export const bindAllinpayPhone = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/bind_phone',
    method: 'POST'
  })
}
export const createAllinpayMember = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/create_member',
    method: 'POST'
  })
}
export const sendAllinpayVerificationCode = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/send_verification_code',
    method: 'POST'
  })
}
export const setAllinpayPayPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/set_pay_pwd',
    method: 'POST'
  })
}
export const setAllinpayRealName = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/set_real_name',
    method: 'POST'
  })
}
export const signAllinpayAccountProtocol = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/sign_acct_protocol',
    method: 'POST'
  })
}
export const confirmAllinpayPayByPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/order/pay_confirm_by_front_pwd',
    method: 'POST'
  })
}
export const confirmAllinpayPayBySms = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/order/pay_confirm_by_front_sms',
    method: 'POST'
  })
}
export const unbindAllinpayBankCard = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/unbind_bank_card',
    method: 'PUT'
  })
}
export const updateAllinpayPayPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/update_pay_pwd',
    method: 'PUT'
  })
}
export const resetAllinpayPayPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/reset_pay_pwd',
    method: 'PUT'
  })
}
export const updateAllinpayPhoneByPayPassword = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/allinpay/member/update_phone_by_pay_pwd',
    method: 'PUT'
  })
}
export const payOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/pay/order',
    method: 'POST'
  })
}
export const payFlashOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/pay/flash/order',
    method: 'POST'
  })
}
export const payBalanceOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/pay/pay_balance',
    method: 'POST'
  })
}
export const payRechargeOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/pay/recharge',
    method: 'POST'
  })
}
export const payVipOrder = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_payment/pay/vip',
    method: 'POST'
  })
}
